import { changeHTMLAttribute } from "./utils"
import {
  changeLayoutAction,
  changeLayoutModeAction,
  changeSidebarThemeAction,
  changeLayoutWidthAction,
  changeLayoutPositionAction,
  changeTopbarThemeAction,
  changeLeftsidebarSizeTypeAction,
  changeLeftsidebarViewTypeAction,
  changeSidebarImageTypeAction,
  changePreLoaderAction,
  changeSidebarVisibilityAction,
} from "./reducer"

import { Dispatch } from "redux"

/**
 * Changes the layout type
 * @param layout - The layout type to change to.
 */
export const changeLayout = (layout: string) => async (dispatch: Dispatch) => {
  try {
    if (layout === "twocolumn") {
      document.documentElement.removeAttribute("data-layout-width")
    } else if (layout === "horizontal") {
      document.documentElement.removeAttribute("data-sidebar-size")
    } else if (layout === "semibox") {
      changeHTMLAttribute("data-layout-width", "fluid")
      changeHTMLAttribute("data-layout-style", "default")
    }
    changeHTMLAttribute("data-layout", layout)
    dispatch(changeLayoutAction(layout))
  } catch (error) {
    console.error(error)
  }
}

/**
 * Changes the layout mode
 * @param layoutMode - The layout mode to change to.
 */
export const changeLayoutMode =
  (layoutMode: string) => (dispatch: Dispatch) => {
    try {
      changeHTMLAttribute("data-bs-theme", layoutMode)
      dispatch(changeLayoutModeAction(layoutMode))

      // Sincronizar sidebar y topbar con el modo de layout
      const sidebarTheme = layoutMode === "dark" ? "dark" : "light"
      const topbarTheme = layoutMode === "dark" ? "dark" : "light"
      changeHTMLAttribute("data-sidebar", sidebarTheme)
      dispatch(changeSidebarThemeAction(sidebarTheme))
      changeHTMLAttribute("data-topbar", topbarTheme)
      dispatch(changeTopbarThemeAction(topbarTheme))
    } catch (error) {
      console.error(error)
    }
  }

/**
 * Changes the left sidebar theme
 * @param theme - The theme to apply to the sidebar.
 */
export const changeSidebarTheme =
  (theme: string) => async (dispatch: Dispatch) => {
    try {
      changeHTMLAttribute("data-sidebar", theme)
      dispatch(changeSidebarThemeAction(theme))
    } catch (error) {
      console.error(error)
    }
  }

/**
 * Changes the layout width
 * @param layoutWidth - The layout width to set.
 */
export const changeLayoutWidth =
  (layoutWidth: string) => async (dispatch: Dispatch) => {
    try {
      if (layoutWidth === "lg") {
        changeHTMLAttribute("data-layout-width", "fluid")
      } else {
        changeHTMLAttribute("data-layout-width", "boxed")
      }
      dispatch(changeLayoutWidthAction(layoutWidth))
    } catch (error) {
      console.error(error)
    }
  }

/**
 * Changes the layout position
 * @param layoutPosition - The layout position to set.
 */
export const changeLayoutPosition =
  (layoutPosition: string) => async (dispatch: Dispatch) => {
    try {
      changeHTMLAttribute("data-layout-position", layoutPosition)
      dispatch(changeLayoutPositionAction(layoutPosition))
    } catch (error) {
      console.error(error)
    }
  }

/**
 * Changes the topbar theme
 * @param topbarTheme - The theme to set for the topbar.
 */
export const changeTopbarTheme =
  (topbarTheme: string) => async (dispatch: Dispatch) => {
    try {
      changeHTMLAttribute("data-topbar", topbarTheme)
      dispatch(changeTopbarThemeAction(topbarTheme))
    } catch (error) {
      console.error(error)
    }
  }

/**
 * Changes the sidebar image type
 * @param leftSidebarImageType - The image type to apply to the sidebar.
 */
export const changeSidebarImageType =
  (leftSidebarImageType: string) => async (dispatch: Dispatch) => {
    try {
      changeHTMLAttribute("data-sidebar-image", leftSidebarImageType)
      dispatch(changeSidebarImageTypeAction(leftSidebarImageType))
    } catch (error) {
      console.error(error)
    }
  }

/**
 * Changes the preloader type
 * @param preloaderType - The preloader type to set.
 */
export const changePreLoader =
  (preloaderType: string) => async (dispatch: Dispatch) => {
    try {
      changeHTMLAttribute("data-preloader", preloaderType)
      dispatch(changePreLoaderAction(preloaderType))
    } catch (error) {
      console.error(error)
    }
  }

/**
 * Changes the sidebar size type
 * @param leftSidebarSizeType - The size type for the sidebar.
 */
export const changeLeftsidebarSizeType =
  (leftSidebarSizeType: string) => async (dispatch: Dispatch) => {
    try {
      switch (leftSidebarSizeType) {
        case "lg":
          changeHTMLAttribute("data-sidebar-size", "lg")
          break
        case "md":
          changeHTMLAttribute("data-sidebar-size", "md")
          break
        case "sm":
          changeHTMLAttribute("data-sidebar-size", "sm")
          break
        case "sm-hover":
          changeHTMLAttribute("data-sidebar-size", "sm-hover")
          break
        default:
          changeHTMLAttribute("data-sidebar-size", "lg")
      }
      dispatch(changeLeftsidebarSizeTypeAction(leftSidebarSizeType))
    } catch (error) {
      console.error(error)
    }
  }

/**
 * Changes the sidebar view type
 * @param leftSidebarViewType - The view type for the sidebar.
 */
export const changeLeftsidebarViewType =
  (leftSidebarViewType: string) => async (dispatch: Dispatch) => {
    try {
      changeHTMLAttribute("data-layout-style", leftSidebarViewType)
      dispatch(changeLeftsidebarViewTypeAction(leftSidebarViewType))
    } catch (error) {
      console.error(error)
    }
  }

/**
 * Changes the sidebar visibility
 * @param sidebarVisibilityType - The visibility type for the sidebar.
 */
export const changeSidebarVisibility =
  (sidebarVisibilityType: string) => async (dispatch: Dispatch) => {
    try {
      changeHTMLAttribute("data-sidebar-visibility", sidebarVisibilityType)
      dispatch(changeSidebarVisibilityAction(sidebarVisibilityType))
    } catch (error) {
      console.error(error)
    }
  }
